export default "__VITE_ASSET__M_75CeoK__"